import React from 'react';
import { useSelector } from 'react-redux';
import Label from '../jadwalguru/Label';
import TeacherSelect from './TeacherSelect';
import KelasSelectWK from './KelasSelectWK';

function DetailForm() {
    const { errors } = useSelector((state) => state.waliKelas);

    return (
        <div className='form'>
            <div className='jabatan-gender' style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                <Label label='Guru' />
                <TeacherSelect />
                <p className='validator-text'>{errors.user_id}</p>
            </div>

            <div className='jabatan-gender'  style={{display: 'flex', flexDirection: 'column', gap: '5px'}}>
                <Label label='Kelas' />
                <KelasSelectWK />
                <p className='validator-text'>{errors.class_id}</p>
            </div>
        </div>
    );
}

export default DetailForm;
